<script>
import MobileLayout from '@layouts/mobile.vue';

import ChatList from '@components/chat/chat-list.vue';

export default {
  page: {
    title: 'Chat',
    meta: [{ name: 'description', content: 'The Chat page.' }],
  },
  components: { MobileLayout, ChatList },
};
</script>

<template>
  <MobileLayout>
    <div class="mobile-header">
      <span />
      <span class="header-title">Trainer Chat</span>
      <span />
    </div>
    <ChatList />
  </MobileLayout>
</template>

<style lang="scss" scoped>
@import '@design';
// stylelint-disable selector-pseudo-element-no-unknown

.mobile-header {
  align-items: center;
  display: grid;
  font-size: 18px;
  grid-column-end: 3;
  grid-column-start: 1;
  grid-row-end: 1;
  grid-row-start: 1;
  grid-template-columns: repeat(3, 1fr);
  height: 9rem;
  padding-left: 2.5rem;
  padding-right: 2.5rem;
  padding-top: 30px;
  span {
    div {
      height: fit-content;
      width: fit-content;
    }
  }
  .header-title {
    color: #000;
    font-family: $roboto;
    font-weight: 500;
    text-align: center;
    text-transform: capitalize;
  }
  img {
    border-radius: 50%;
    height: 35px;
    justify-self: flex-end;
    object-fit: cover;
    width: 35px;
  }
}

.mobile_container_2BHk3 {
  height: 100vh;
  position: relative;
}
::v-deep .messages-container {
  box-shadow: unset;
  height: calc(100vh - 170px);
  justify-content: space-between;
  max-height: 90%;
  position: relative;
  width: 100vw;
  .messages-list {
    box-shadow: 0 4px 4px -4px rgba(0, 0, 0, 0.25);
    height: calc(100% - 6.8rem);
    position: relative;
    .messages-wrapper {
      height: 100%;
      max-height: calc(100%);
      .message-container {
        margin-bottom: 1.5rem;
        .message-text {
          padding: 1rem;
        }
      }
    }
  }
  .message-input-wrapper {
    box-shadow: unset;
    justify-content: space-around;
    margin-bottom: 1rem;
    // padding-top: 0.8rem;
    .textarea-wrapper {
      width: 88%;
    }
    .send-arrow {
      height: 4.5rem;
      width: 4.5rem;
    }
  }
}
</style>
